import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '../icons';

/**
 * Subscription Complete Page (public, no auth required)
 *
 * Landing page for Stripe checkout completed in the system browser by the
 * iOS app (Apple guideline 3.1.1 link-out). The user is typically logged
 * out in Safari, so this page must not require a session — it only confirms
 * payment and directs them back to the app, where AuthContext picks up the
 * new subscription automatically.
 */
function SubscriptionComplete() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: (theme) => theme.palette.grey[100],
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={2} sx={{ borderRadius: '0.75rem' }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '5rem',
                height: '5rem',
                borderRadius: '50%',
                backgroundColor: (theme) => theme.palette.success.light,
                mb: 3,
              }}
            >
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: '3rem',
                  color: (theme) => theme.palette.success.dark,
                }}
              />
            </Box>

            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 600,
                color: (theme) => theme.palette.text.primary,
                mb: 2,
              }}
            >
              You're all set!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: (theme) => theme.palette.text.secondary,
                mb: 1,
                lineHeight: 1.6,
              }}
            >
              Your Membership is active.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: (theme) => theme.palette.text.secondary,
                lineHeight: 1.6,
              }}
            >
              Return to the myStack app to continue.
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default SubscriptionComplete;
